// Packages
import React, { useState, useEffect } from 'react';
import { createColumnHelper } from "@tanstack/react-table";
import { isEmpty } from "lodash";
import { useNavigate, useOutletContext } from 'react-router-dom';

// Hook
import useTableInstance from "hooks/useTableInstance";

// Components
import { useTheme } from "@mui/material/styles";
import { Box, Card } from "@mui/material";
import TableField from "components/Table";

// Utils
import localStorageUtil from "utils/localStorageUtil";
import { initClientTableData } from '../util';

// Const
import { getClientsTableColumns } from '../const';

const ClientsContent = ({
  auth,
  infoData,
  clientRowData
}) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const columnHelper = createColumnHelper();
  const { scopeData } = useOutletContext();
  const [clientTableData, setClientTableData] = useState([]);

  const handelClient = clientId => {
    if (auth.scopeLevel === "org") {
      const selectedSite = scopeData.site.find(site => site.id === infoData.siteId);
      if (selectedSite) localStorageUtil.updateItemField("selectBreadcrumbs", "site", selectedSite);
    }

    navigate("/clients", {
      state: {
        navigateClientId: clientId,
      }
    });
  }

  const clientsTableInstance = useTableInstance({
    tableName: "DeviceClients",
    data: clientTableData,
    columns: getClientsTableColumns({
      auth,
      columnHelper,
      theme,
      callbacks: {
        handelClient
      }
    }),
    enableSorting: true,
    enableColumnOrder: false,
    enableRowSelection: true,
    enablePagination: false,
  });

  useEffect(() => {
    const tmpClientTableData = initClientTableData({clientRowData});
    setClientTableData(tmpClientTableData);
  }, [clientRowData]);

  return (
    <>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          p: 2,
          boxSizing: "border-box",
        }}
      >
        <Card
          sx={{
            maxWidth: 560,
            width: "100%",
            height: "100%",
            borderRadius: theme.shape.customBorderRadius[4],
            border: `1px solid  ${theme.palette.primary.greyThread}`,
            margin: "16px"
          }}
        >
          <TableField
            {...clientsTableInstance}
            pendingChildren={
              <>
                {
                  isEmpty(clientTableData) ?
                  <Box>No data</Box> :
                  <></>
                }
              </>
            }
          />

        </Card>
      </Box>
    </>
  )
};

export default ClientsContent;